
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/life/[slug]",
      function () {
        return require("private-next-pages/life/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/life/[slug]"])
      });
    }
  